import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import RequireProfile from "./components/RequireProfile";
import { initAnalytics } from "./lib/analytics";
import "./index.css";
import RecoveryRedirect from "./components/RecoveryRedirect";
import MatomoRouteTracker from "./components/MatomoRouteTracker";

const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const Profile = lazy(() => import("./pages/Profile"));
const Onboarding = lazy(() => import("./pages/Onboarding"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Cookies = lazy(() => import("./pages/Cookies"));
const Terms = lazy(() => import("./pages/Terms"));
const Legal = lazy(() => import("./pages/Legal"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const IRPFGuide = lazy(() => import("./pages/guides/IRPFGuide"));
const RETAGuide = lazy(() => import("./pages/guides/RETAGuide"));
const Modelo130Guide = lazy(() => import("./pages/guides/Modelo130Guide"));
const DeduccionesGuide = lazy(() => import("./pages/guides/DeduccionesGuide"));

function LoadingFallback() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '16px',
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid #e5e7eb',
        borderTopColor: '#3b82f6',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ fontSize: '14px', color: '#64748b' }}>Cargando...</p>
    </div>
  );
}
import CookieBanner from "./components/CookieBanner";
import { AuthProvider } from "./contexts/AuthContext";

initAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <RecoveryRedirect />
          <MatomoRouteTracker />
          <Routes>
            <Route path="/" element={<RequireProfile><App /></RequireProfile>} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/profile" element={<RequireProfile><Profile /></RequireProfile>} />
            <Route path="/guia/irpf-autonomos" element={<IRPFGuide />} />
            <Route path="/guia/cuota-autonomos-reta" element={<RETAGuide />} />
            <Route path="/guia/modelo-130" element={<Modelo130Guide />} />
            <Route path="/guia/deducciones-autonomos" element={<DeduccionesGuide />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/legal" element={<Legal />} />
          </Routes>
        </Suspense>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>
);
